import * as items from './items.jsx';
import * as transactions from './transactions.jsx';
import * as salesReports from './reports/sales.jsx';

module.exports = {
  items: items,
  transactions: transactions,
  salesReports: salesReports
};
